if (!customElements.get('ffn-pack-showcase')) {
  customElements.define('ffn-pack-showcase', class FFNPackShowcase extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-pack-target]')];
      this.panels = [...this.querySelectorAll('[data-pack-panel]')];
      this.progress = this.querySelector('.ffn-pack-showcase__progress span');
      this.delay = Number(this.dataset.interval) || 6200;
      this.index = Math.max(0, this.panels.findIndex((panel) => panel.classList.contains('is-active')));
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.mobileQuery = window.matchMedia('(max-width: 760px)');
      this.onVisibilityChange = () => document.hidden ? this.stop() : this.start();
      this.onModeChange = () => {
        this.show(this.index, false);
        this.start();
      };
      this.onBlockSelect = (event) => {
        const panelIndex = this.panels.indexOf(event.target);
        if (panelIndex >= 0) this.show(panelIndex, true);
      };

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.show(index, true));
        tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
      });

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.start();
      });
      this.mobileQuery.addEventListener('change', this.onModeChange);
      document.addEventListener('visibilitychange', this.onVisibilityChange);
      document.addEventListener('shopify:block:select', this.onBlockSelect);

      this.show(this.index, false);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      this.mobileQuery?.removeEventListener('change', this.onModeChange);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    show(index, restart = true) {
      if (!this.panels.length) return;
      this.index = (index + this.panels.length) % this.panels.length;
      this.updatePanels();
      this.tabs.forEach((tab, tabIndex) => {
        const active = tabIndex === this.index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.dataset.activeWorld = this.panels[this.index].dataset.world;
      const section = this.closest('#ffn-packs');
      if (section) section.dataset.activeWorld = this.dataset.activeWorld;
      this.resetProgress();
      if (restart) this.start();
    }

    updatePanels() {
      const mobile = this.mobileQuery.matches;
      this.panels.forEach((panel, panelIndex) => {
        const active = panelIndex === this.index;
        panel.classList.toggle('is-active', active);
        panel.setAttribute('aria-hidden', String(mobile ? false : !active));
        panel.toggleAttribute('inert', mobile ? false : !active);
      });
    }

    onKeydown(event, index) {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const target = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1);
      const next = (target + this.tabs.length) % this.tabs.length;
      this.show(next, true);
      this.tabs[next].focus();
    }

    start() {
      this.stop();
      if (this.reducedMotion || this.mobileQuery.matches || document.hidden || this.panels.length < 2) return;
      this.resetProgress();
      this.timer = window.setTimeout(() => this.show(this.index + 1, true), this.delay);
    }

    stop() {
      window.clearTimeout(this.timer);
      this.timer = null;
      this.classList.remove('is-timing');
    }

    resetProgress() {
      if (!this.progress || this.reducedMotion) return;
      this.style.setProperty('--pack-duration', `${this.delay}ms`);
      this.classList.remove('is-timing');
      void this.offsetWidth;
      this.classList.add('is-timing');
    }
  });
}
